import PropTypes from "prop-types";

import FnrIcon from "UI/FnrIcon/FnrIcon";

import { GridContainer, IconContainer } from "./FnrIconGridContainers";
import iconNames from "./iconNames";

// make none optional
const FnrIconGrid = ({
  selected,
  onSelect = () => {},
  showEmptyOption = false,
}) => (
  <GridContainer $variant="selectList" data-cy="IconGrid_Container">
    {showEmptyOption && (
      <IconContainer
        $selected={!selected}
        data-cy="IconGrid_IconContainer"
        onClick={() => onSelect("")}
      >
        <FnrIcon icon="" />
      </IconContainer>
    )}
    {iconNames.map((className) => (
      <IconContainer
        $selected={selected === className}
        data-cy="IconGrid_IconContainer"
        key={className}
        onClick={() => onSelect(className)}
      >
        <FnrIcon icon={className} />
      </IconContainer>
    ))}
  </GridContainer>
);

FnrIconGrid.propTypes = {
  selected: PropTypes.string,
  onSelect: PropTypes.func,
  showEmptyOption: PropTypes.bool,
};

export default FnrIconGrid;
